<template>
 <v-layout row wrap >
    <v-flex xs12>
      <v-container ma-0>
        <div class="display-1 primary--text">{{$t('company.footer.terms.title')}}</div>
        <v-divider class="primary divider-custom-height my-1"></v-divider>
        <div class="my-4 ">
            <div class="pb-1 custom_font_size secondary--text" v-for="(term) in terms" :key="term.text"  v-html="term.text">
        </div>
        </div>
      </v-container>
    </v-flex>
  </v-layout>
</template>
<script>
import i18n from "@/i18n";
export default {
  name: "Terms",
  data: () => ({
    terms: [
      { text: i18n.t("company.footer.terms.point_1") },
      { text: i18n.t("company.footer.terms.point_2") },
      { text: i18n.t("company.footer.terms.point_3") },
      { text: i18n.t("company.footer.terms.point_4") },
      { text: i18n.t("company.footer.terms.point_5") },
      { text: i18n.t("company.footer.terms.point_6") },
      { text: i18n.t("company.footer.terms.point_7") },
      { text: i18n.t("company.footer.terms.point_8") },
      { text: i18n.t("company.footer.terms.point_9") },
      { text: i18n.t("company.footer.terms.point_10") },
      { text: i18n.t("company.footer.terms.point_11") },
      { text: i18n.t("company.footer.terms.point_12") },
      { text: i18n.t("company.footer.terms.point_13") },
      { text: i18n.t("company.footer.terms.point_14") },
      { text: i18n.t("company.footer.terms.point_15") },
      { text: i18n.t("company.footer.terms.point_16") },
      { text: i18n.t("company.footer.terms.point_17") },
      { text: i18n.t("company.footer.terms.point_18") },
      { text: i18n.t("company.footer.terms.point_19") },
      { text: i18n.t("company.footer.terms.point_20") },
      { text: i18n.t("company.footer.terms.point_21") },
      { text: i18n.t("company.footer.terms.point_22") },
      { text: i18n.t("company.footer.terms.point_23") },
      { text: i18n.t("company.footer.terms.point_24") },
      { text: i18n.t("company.footer.terms.point_25") },
      { text: i18n.t("company.footer.terms.point_26") },
      { text: i18n.t("company.footer.terms.point_27") },
      { text: i18n.t("company.footer.terms.point_28") },
      { text: i18n.t("company.footer.terms.point_29") },
      { text: i18n.t("company.footer.terms.point_30") },
      { text: i18n.t("company.footer.terms.point_31") },
      { text: i18n.t("company.footer.terms.point_32") },
      { text: i18n.t("company.footer.terms.point_33") },
      { text: i18n.t("company.footer.terms.point_34") },
      { text: i18n.t("company.footer.terms.point_35") },
      { text: i18n.t("company.footer.terms.point_36") },
      { text: i18n.t("company.footer.terms.point_37") },
      { text: i18n.t("company.footer.terms.point_38") },
      { text: i18n.t("company.footer.terms.point_39") },
      { text: i18n.t("company.footer.terms.point_40") },
      { text: i18n.t("company.footer.terms.point_41") },
      { text: i18n.t("company.footer.terms.point_42") },
      { text: i18n.t("company.footer.terms.point_43") },
      { text: i18n.t("company.footer.terms.point_44") },
      { text: i18n.t("company.footer.terms.point_45") },
      { text: i18n.t("company.footer.terms.point_46") }, 
    ]
  })

};
</script>